<template>
  <div id="app">
    <Header />
    <!-- Router view will display the routed components (Home, Products, etc.) -->
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';

export default {
  components: {
    Header,
    Footer
  }
};
</script>
